import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getManageProfileRoute } from '../../auth';
import { useAuth } from 'react-oidc-context';
import { usePermissionContext } from '../../auth/AuthContext';
import { Person } from 'react-bootstrap-icons';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { Collapse } from 'react-bootstrap';
export const UserDropdownComponent  = () =>
{ 
    const auth = useAuth();
    const userName = auth.user?.profile?.given_name ? auth.user.profile.given_name : "User";
    const { authRoles, hasRole, activeRole, setActiveRole } = usePermissionContext();
    const [showRoles, setShowRoles] = React.useState(false);

    const goToManageProfile = () => {
        window.location.href = getManageProfileRoute(); // Navigate to a different domain);
    }
    
    const handleLogout = async () =>
    {
        const id_token = auth.user?.id_token;
        await auth.removeUser();
        auth.signoutRedirect({ id_token_hint: id_token });
    }

    const goToAdminPage = () =>
    {
        window.location.href = "/admin";
    }

    return(
        <Dropdown id='user-dropdown'>
            <Dropdown.Toggle className="button-header button-icon" id = "user-dropdown">
                <span className="d-none d-md-inline">Hi {userName}</span>
                <Person className="d-md-none"/>
            </Dropdown.Toggle>
            <Dropdown.Menu
                id="user-dropdown-menu"
                align={'end'}>
                <Dropdown.Item className="user-dropdown-button" onClick={goToManageProfile}>Profile</Dropdown.Item>
                {
                    hasRole('Admin') && 
                    <Dropdown.Item className="user-dropdown-button" onClick={goToAdminPage}>Admin</Dropdown.Item>
                }
                <Dropdown.Divider />
                <Dropdown.Item className="user-dropdown-button" onClick={handleLogout}>Logout</Dropdown.Item>                
            </Dropdown.Menu>
        </Dropdown>
    )
}
